module.exports = __webpack_public_path__ + "static/media/nanostring.205de8c0.png";